import { render, staticRenderFns } from "./UnderstandingBlock.vue?vue&type=template&id=9a11c9c8&scoped=true&"
import script from "./UnderstandingBlock.vue?vue&type=script&lang=js&"
export * from "./UnderstandingBlock.vue?vue&type=script&lang=js&"
import style0 from "./UnderstandingBlock.vue?vue&type=style&index=0&id=9a11c9c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a11c9c8",
  null
  
)

export default component.exports